import { FieldValues } from 'react-hook-form';

import { getSystemTypeConfig } from 'features/systems/config/system-type-registry';
import { useSystemsContextProvider } from 'features/systems/context/systems-provider';
import { SystemType } from 'features/systems/domain/models/system';
import useSystemDetailsSubmission from './system-details-submission';
import useSystemRefreshOnSuccess from './system-refresh-on-success';

type UseSystemDetailsContentReturn = {
  handleSubmitForm: (fieldValues: FieldValues) => void;
  resetForm?: () => void;
};

const useSystemDetailsContent = (systemType: SystemType): UseSystemDetailsContentReturn => {
  const { systemsDetailsHook } = useSystemsContextProvider();
  const { selectedSystem, updateSystemFromForm, updateSystemIsSuccess, refreshSystem } = systemsDetailsHook;

  const config = getSystemTypeConfig(systemType);
  const configurationHook = config.useConfiguration?.();

  const { handleSubmitForm } = useSystemDetailsSubmission({
    systemType,
    selectedSystem,
    updateSystemFromForm,
  });

  useSystemRefreshOnSuccess({
    systemType,
    updateSystemIsSuccess,
    refreshSystems: refreshSystem,
  });

  return {
    handleSubmitForm,
    resetForm: configurationHook?.resetForm,
  };
};

export default useSystemDetailsContent;
